import React, { useEffect, useState } from 'react'
import { Button, InputGroup, Form } from 'react-bootstrap';
import ExchangeIcon from '../IconBox/ExchangeIcon'
import { BlockchainApproveToken, BlockchainBuyToken, getUsdtBalance } from '../../../Web3/Connector';
import { ERROR, Success, Warning } from '../../../../utils/errors';
import config from '../../../../config'
import { useNavigate } from 'react-router';
import Web3ModalProvider from '../Connectwallet/Web3ModalProvider';
import toast, { Toaster } from 'react-hot-toast';

const Swapform = ({ setIsProcessing, usdtBalance, InfiTokenPrice, walletConnnected, UsdtContract, presaleContract }) => {

    const navigate = useNavigate();
    const _useWeb3ModalProvider = Web3ModalProvider()


    const [UsdtAmount, setUsdtAmount] = useState('');
    const [infiToken, setInfiToken] = useState('');
    const [isApproved, setisApproved] = useState(false);
    const [ApproveInterval, setApproveInterval] = useState();
      const [WalletAddress, setWalletAddress] = useState("")
    const spaceRight = {
        paddingRight: '50px',
    };

    const onchangehandler = (e) => {
        const { value, name } = e.target;
        setisApproved(false);
        if (name == 'infiToken') {
            setInfiToken(value);
            setUsdtAmount(parseFloat(value * InfiTokenPrice).toFixed(6))
        } else {
            setUsdtAmount(value);
            setInfiToken(parseFloat(value / InfiTokenPrice).toFixed(6))
        }
    }
  useEffect(() => {
    if (walletConnnected) {
      setWalletAddress(walletConnnected);
    }
  }, [walletConnnected]);
    const setMax = () => {
        setUsdtAmount(usdtBalance)
        setInfiToken(parseFloat(usdtBalance / InfiTokenPrice).toFixed(6))
    }

    const approveToken = async () => {
        if (1 > parseFloat(UsdtAmount)) {
            Warning("Minimum purchase amount should be 1 USDT");
            return;
        }
        const res = await getUsdtBalance(walletConnnected, UsdtContract, presaleContract, _useWeb3ModalProvider);
        if (parseFloat(res?.balance || 0) < parseFloat(UsdtAmount)) {
            Warning("Insufficeint USDT for buy token");
            return;
        }

        setIsProcessing(true);

        if (parseFloat(res.allowance) >= parseFloat(UsdtAmount)) {
            setisApproved(true);
            setIsProcessing(false);
            return;
        }
        const approval = await BlockchainApproveToken({
            walletProvider: await _useWeb3ModalProvider,
            walletAddress: WalletAddress,
            UsdtContract: UsdtContract,
            presaleContract: presaleContract,
            UsdtAmount: UsdtAmount,
        });
        console.log('xxxxx2',approval)
        if (approval.status) {
            const id = setInterval(async () => {
                await approvalCheck()
            }, 1000);

            setApproveInterval(id);

        } else {
            setIsProcessing(false);
            toast.error('Error approving usdt:' + JSON.stringify(approval.message))
        }
    }

    useEffect(() => {
        if (isApproved) {
            console.log("Cleared interval..");
            clearInterval(ApproveInterval);
            buyToken()
        }
    }, [isApproved])

    const approvalCheck = async () => {
        const res = await getUsdtBalance(walletConnnected, UsdtContract, presaleContract, _useWeb3ModalProvider);
        if (parseFloat(res.allowance) >= parseFloat(UsdtAmount)) {
            setisApproved(true);
            console.log("Approved interval..");
        } else {
            console.log("check approval : ")
            console.log({ UsdtAmount, allowance: res.allowance });
        }
    }

    const buyToken = async () => {
        setIsProcessing(true);
        const resBuy = await BlockchainBuyToken({
            walletProvider: await _useWeb3ModalProvider,
            walletAddress: WalletAddress,
            UsdtContract: UsdtContract,
            presaleContract: presaleContract,
            UsdtAmount: UsdtAmount,
        });
     console.log('xxxxx',resBuy)
        setIsProcessing(false);
        if (resBuy.status) {
            setisApproved(true)
            Success("Token purchased successfully, It will take a few minutes to confirm the transaction.");
            setTimeout(() => {
                navigate(`${config.baseurl}dashboard`);
            }, 2000)
        } else {
            toast.error('Error buying tokens:' + JSON.stringify(resBuy.message))
        }
    }

    return (
        <>
        <Toaster/>
            <div className='Sawpform outlineField pb-3'>
                <div className='text-center mb-3'>
                    <h2>Buy with USDT</h2>
                </div>
                <Form.Group>
                    <Form.Label className='mb-1 small'><b>USDT Amount</b>
                        <span className=''> Balance : {usdtBalance || 0} USDT</span>
                    </Form.Label>
                    <InputGroup className="mb-4">

                        <Form.Control
                            aria-describedby="basic-addon2"
                            style={spaceRight}
                            className='rounded-2'
                            value={UsdtAmount}
                            name="UsdtAmount"
                            onChange={onchangehandler}
                        />
                        <Button type='button' variant='default' onClick={setMax} className='border-0  h-auto text-blue position-absolute end-0 bg-transparent rounded-2 z-3 cursor-pointer'>
                            MAX
                        </Button>
                    </InputGroup>
                </Form.Group>
                <div className='exchangeIcon text-center'>
                    <Button variant='default' className='bg-transparent'>
                        <ExchangeIcon />

                    </Button>
                </div>
                <Form.Group className='mb-3' style={{ marginTop: "-1px" }}>

                    <Form.Label className='mb-1 small'>INFI Token
                    </Form.Label>
                    <InputGroup className="mb-3">

                        <Form.Control
                            aria-describedby="basic-addon2"
                            value={`${infiToken}`}
                            name="infiToken"
                            onChange={onchangehandler}
                        />

                    </InputGroup>
                </Form.Group>
                <div className='mb-3'>
                    <small>Step 1. Approve USDT</small><br />
                    <small>Step 2. Buy INFI</small>
                </div>

                {!isApproved &&
                    <Button variant='primary' className='text-black w-100 fw-medium mb-3' onClick={approveToken}>Buy Now</Button>}
                    
                {isApproved &&
                    <Button variant='primary' className='text-black w-100 fw-medium mb-3' onClick={buyToken}>Buy Now</Button>}
                    
                    <div className='text-center position-relative'>
                    {/* {<MoonPayProvider apiKey={web3Config.MOONPAY_API} debug> */}
                        {/* <div>
                            <MoonPayBuyWidget variant='embedded'
                                baseCurrencyCode='usd'
                                baseCurrencyAmount='10'
                                defaultCurrencyCode='polygon'
                                visible={visible}
                                style={{ margin: "0rem", height: "300px" }} />
                        </div> */}
                        {/* <a href='#' className='text-decoration-none' onClick={(e) => { e.preventDefault(); setVisible(!visible); }}
                            style={{ color: 'white' }} >
                            {visible ? <Button variant='primary' className='text-black h-auto lh-1 px-2 closebtn position-absolute' style={{right:"-10px",top:"-10px"}}><IoMdClose /></Button> : <div>Dont have USDT? <u className='text-primary'> Click here</u></div>}
                        </a> */}
                    {/* </MoonPayProvider>} */}
                </div>
            </div>
        </>
    );
}

export default Swapform